/**
 *
 * @author Aleynikov Boris <alynikov.boris@gmail.com>.
 */

'use strict';

var $title = document.getElementById('advertisingTitle'),
    format = require('cjs-format');


/**
 * Write current advertising file from total text
 *
 * @param {number} current - current position
 * @param {number} total - total count
 */
module.exports = function ( current, total ) {
    $title.innerText = format(gettext('Advertising {0} of {1}'), current, total);
};
